// extracted by mini-css-extract-plugin
module.exports = {"menu":"HamburgerMenu_menu__qxdpy","section":"HamburgerMenu_section__3P_za","context":"HamburgerMenu_context__1OINU","buttonGroup":"HamburgerMenu_buttonGroup__xIsWC"};